var map = {
	"./afb-color.svg": 1618,
	"./afb.svg": 1619,
	"./alb-color.svg": 1620,
	"./alb.svg": 1621,
	"./amb-color.svg": 1622,
	"./amb.svg": 1623,
	"./bbbaidjaxxx-color.svg": 1624,
	"./bdinidjaxxx-color.svg": 1625,
	"./bimb-color.svg": 1626,
	"./bimb.svg": 1627,
	"./bkr-color.svg": 1628,
	"./bkr.svg": 1629,
	"./bmriidja-color.svg": 1630,
	"./bniaidja-color.svg": 1631,
	"./bninidjaxxx-color.svg": 1632,
	"./brinidja002-color.svg": 1633,
	"./bsmdidjaxxx-color.svg": 1634,
	"./bsn-color.svg": 1635,
	"./bsn.svg": 1636,
	"./btanidjaxxx-color.svg": 1637,
	"./cenaidjaxxx-color.svg": 1638,
	"./cimb-color.svg": 1639,
	"./cimb.svg": 1640,
	"./citi-color.svg": 1641,
	"./citi.svg": 1642,
	"./default-bank-icon-color.png": 1643,
	"./default-bank-icon.png": 1644,
	"./hlb-color.svg": 1645,
	"./hlb.svg": 1646,
	"./hsbc-color.svg": 1647,
	"./hsbc.svg": 1648,
	"./ibbkidja003-color.svg": 1649,
	"./kwh-color.svg": 1650,
	"./kwh.svg": 1651,
	"./mbb-color.svg": 1652,
	"./mbb.svg": 1653,
	"./nispidjaxxx-color.svg": 1654,
	"./ocbc-color.svg": 1655,
	"./ocbc.svg": 1656,
	"./pbb-color.svg": 1657,
	"./pbb.svg": 1658,
	"./pinbidjaxxx-color.svg": 1659,
	"./rhb-b.svg": 1660,
	"./rhb-color-b.svg": 1661,
	"./rhb-color.svg": 1662,
	"./rhb.svg": 1663,
	"./scb-color.svg": 1664,
	"./scb.svg": 1665,
	"./uob-color.svg": 1666,
	"./uob.svg": 1667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;